import imgOption1 from "/public/Images/Option1Bandpullsfar.gif";
import imgOption2 from "/public/Images/Option2Bandpullsokay.gif";
import imgOption3 from "/public/Images/Option3Bandlooksgood.gif";
import tightestHook from "/public/Images/TightestHook.jpg";
import loosestHook from "/public/Images/loosestHook.jpg";
import cupOption1 from "/public/Images/cupOption1.gif";
import cupOption2 from "/public/Images/cupOption2.gif";
import cupOption3 from "/public/Images/cupOption3.gif";
import cupOption4 from "/public/Images/cupOption4.gif";
import cupOption5 from "/public/Images/cupOption5.gif";
import scoopBreasts from "/public/Images/scoopBreasts.gif";

// bf0
export const bf0 = [
  {
    id: 1,
    type: "braSizeInput",
    content:
      "Let’s get you ready! Grab your best-fitting bra and take a look at the size on the label.",
    next: 2,
  },
  {
    id: 2,
    type: "prompt",
    content:
      "Is this your everyday bra which you’ve worn often in the last 3 months?",
    options: [
      { label: "Yes", next: 3 },
      { label: "No", next: 9 }, // Shows different GIF on loosest hook
    ],
  },
  {
    id: 3,
    type: "textPromptWithImages",
    content:
      "Thanks for that. Now let’s put the bra on the tightest hooks for me. We are measuring your band size here, make sure to pull the band down so it’s parallel to the front band & adjust your straps, like this image below.",
    image: tightestHook,
    option: { label: "I am ready to proceed", next: 4 },
  },
  {
    id: 9,
    type: "textPromptWithImages",
    content:
      "Thank you. Now, let's put the bra on, fastening on the loosest hooks. We are measuring your band size here, make sure to pull the band down so it’s parallel to the front band & adjust your straps, like this gif below.",
    image: loosestHook,
    option: { label: "I am ready to proceed", next: 4 },
  },
  {
    id: 4,
    type: "promptWithImages",
    content:
      "Now, pull the band away from your body. Which gif below resonates the most?.",
    options: [
      {
        label: "Band pulls far",
        next: 5,
        image: imgOption1,
      },
      {
        label: "Band pulls okay",
        next: 5,
        image: imgOption2,
      },
      {
        label: "Band looks good",
        next: 5,
        image: imgOption3,
      },
    ],
  },
  {
    id: 5,
    type: "textPromptWithImages",
    content:
      "Now let’s check the cup size. First, lean forward slightly and scoop the breasts from your side to the front of the cup. Like this gif below",
    image: scoopBreasts,
    option: { label: "I am ready to proceed", next: 6 },
  },
  {
    id: 6,
    type: "promptWithImages",
    content: "When you are ready, which image below resonates the most? \n\
      Check the fuller side of the breasts",
    options: [
      {
        label: "spills significantly",
        next: 7,
        image: cupOption1,
      },
      { label: "spills slightly", next: 7, image: cupOption2 },
      { label: "cup looks good", next: 7, image: cupOption3 },
      { label: "gapes slightly", next: 7, image: cupOption4 },
      { label: "gapes significantly", next: 7, image: cupOption5 },
    ],
  },
  {
    id: 7,
    type: "result",
    content:
      "Your recommended size based on the current fit is: {band-cup size}.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  // todo add new type for failed result
  {
    id: 8,
    type: "result",
    content:
      "Unfortunately, we currently need this in order to properly fit you. Whenever you’re ready, I’m always available here for our fitting.",
  },
];
